import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import api from "@/lib/api";

export const usePaymentStatus = () => {
  const [st, setSt] = useState(null);
  useEffect(() => { api.get("/payment-status").then(({ data }) => setSt(data)).catch(() => {}); }, []);
  return st;
};

export default function PaymentReminder() {
  const st = usePaymentStatus();
  if (!st?.show_reminder) return null;
  return (
    <div className="nb-card bg-sky-50 border-2 border-slate-900 p-4 mb-6 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="payment-reminder">
      <CalendarClock className="text-sky-600 shrink-0" size={26} />
      <div className="flex-1">
        <p className="font-bold" data-testid="payment-reminder-title">Friendly reminder: the {st.due_label} payment is due on {st.due_date}</p>
        <p className="text-slate-600 text-sm">
          Bank transfer to KMP Lagoon Rentals Ltd · MCB 000456560130.
          {st.reference && <> Please use the reference <span className="font-semibold text-slate-800" data-testid="payment-reminder-reference">{st.reference}</span>.</>}
          {" "}If you have already paid, thank you! It will disappear once we confirm it.
        </p>
      </div>
      <Link to="/pricing" className="shrink-0 rounded-full bg-white border-2 border-slate-900 px-4 py-2 text-sm font-semibold hover:bg-sky-100" data-testid="payment-reminder-details">Payment details</Link>
    </div>
  );
}
